var _path, _path2, _g, _path3, _path4, _path5, _g2, _path6, _g3, _path7, _g4, _path8, _path9, _path0, _path1, _g5, _path10, _path11, _g6, _path12, _g7, _path13, _path14, _path15, _path16, _path17, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJ1772Socket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 79,
    viewBox: "0 0 66 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.8513 9.7976C44.827 6.06565 43.3425 2.70994 40.9914 0.367614C40.5915 -0.0328875 39.9007 0.270523 39.9007 0.834866V2.50969H26.1336V0.652819C26.1336 0.0945449 25.461 -0.214933 25.055 0.173432C22.5889 2.52183 21.0195 5.9625 20.9952 9.7976H44.8513Z",
    fill: "#445B68"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8098 2.50967H26.0427V8.15917H39.8098V2.50967Z",
    fill: "#445B68"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.7193 3.14077C38.5858 3.14077 39.2887 3.84468 39.2887 4.71243V7.31569C39.2887 7.62517 39.1978 7.91037 39.0403 8.15917H39.8037V2.50967H32.8657L37.7193 3.14077Z",
    fill: "#0D1214"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8825 66.2986H25.7822V75.1522H39.8825V66.2986Z",
    fill: "#1E272D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9263 68.2769C17.2262 68.2769 4.45292 55.4001 4.45292 39.5743C4.45292 23.7484 17.2262 10.8717 32.9263 10.8717C48.6263 10.8717 61.3996 23.7484 61.3996 39.5743C61.3996 55.4001 48.6263 68.2769 32.9263 68.2769ZM32.9263 11.4421C17.5413 11.4421 5.02251 24.0579 5.02251 39.5743C5.02251 55.0907 17.5413 67.7065 32.9263 67.7065C48.3112 67.7065 60.83 55.0907 60.83 39.5743C60.83 24.0579 48.3112 11.4421 32.9263 11.4421Z",
    fill: "#88D5FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9263 68.3193C48.6751 68.3193 61.442 55.447 61.442 39.5682C61.442 23.6893 48.6751 10.817 32.9263 10.817C17.1774 10.817 4.41051 23.6893 4.41051 39.5682C4.41051 55.447 17.1774 68.3193 32.9263 68.3193Z",
    fill: "#1E272D"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.27
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.0618 19.2093C47.9052 14.0271 40.7854 10.817 32.9263 10.817C21.4436 10.817 11.5485 17.6619 7.02819 27.5288C7.82804 30.3202 9.71859 32.8628 12.0697 34.6226C15.5902 37.2622 19.9894 38.4273 24.3219 39.1677C29.1028 39.9808 34.0291 40.3449 38.7797 39.374C43.5303 38.4031 48.1173 35.994 51.0016 32.0921C53.7041 28.4451 54.6857 23.4085 53.0497 19.2033L53.0618 19.2093Z",
    fill: "#31404C"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9263 59.5507C43.8728 59.5507 52.7467 50.6042 52.7467 39.5682C52.7467 28.5321 43.8728 19.5856 32.9263 19.5856C21.9797 19.5856 13.1058 28.5321 13.1058 39.5682C13.1058 50.6042 21.9797 59.5507 32.9263 59.5507Z",
    fill: "#445B68"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.0605 32.1468C60.0605 47.0564 47.9901 59.1382 33.1081 59.1382C18.226 59.1382 6.15563 47.0503 6.15563 32.1468C6.15563 31.1152 6.21622 30.1018 6.33135 29.1006C5.14976 32.256 4.5014 35.6724 4.5014 39.2405C4.5014 55.121 17.2687 67.9917 33.0172 67.9917C48.7657 67.9917 61.5329 55.121 61.5329 39.2405C61.5329 35.9334 60.9694 32.7536 59.9514 29.7984C60.0181 30.5751 60.0605 31.3579 60.0605 32.1529V32.1468Z",
    fill: "#0D1214"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6865 45.2177C50.6865 48.4399 48.0749 51.0553 44.8573 51.0553C41.6398 51.0553 39.0281 48.4399 39.0281 45.2177C39.0281 41.9955 41.6398 39.3801 44.8573 39.3801C48.0749 39.3801 50.6865 41.9894 50.6865 45.2177Z",
    fill: "#1E272D"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.8333 44.2893C43.8333 43.4943 44.4332 42.8511 45.1785 42.8511C45.9238 42.8511 46.5237 43.4943 46.5237 44.2893C46.5237 45.0842 45.9238 45.7214 45.1785 45.7214C44.4332 45.7214 43.8333 45.0781 43.8333 44.2893Z",
    fill: "#0D1214"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6184 45.2177C26.6184 48.4399 24.0068 51.0553 20.7892 51.0553C17.5716 51.0553 14.96 48.4399 14.96 45.2177C14.96 41.9955 17.5716 39.3801 20.7892 39.3801C24.0068 39.3801 26.6184 41.9894 26.6184 45.2177Z",
    fill: "#1E272D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5485 45.2905C43.5061 44.4531 44.1484 43.7431 44.9846 43.7006C45.8208 43.6581 46.5358 44.3014 46.5721 45.1388C46.6146 45.9762 45.9723 46.6923 45.1361 46.7287C44.2999 46.7711 43.5848 46.1279 43.5485 45.2905Z",
    fill: "url(#paint0_linear_6_19130)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4402 52.3235C39.4402 55.928 36.5256 58.8468 32.9263 58.8468C29.327 58.8468 26.4124 55.928 26.4124 52.3235C26.4124 48.719 29.327 45.8002 32.9263 45.8002C36.5256 45.8002 39.4402 48.719 39.4402 52.3235Z",
    fill: "#1E272D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4843 30.745C30.4843 34.3495 27.5697 37.2683 23.9704 37.2683C20.3711 37.2683 17.4565 34.3495 17.4565 30.745C17.4565 27.1405 20.3711 24.2217 23.9704 24.2217C27.5697 24.2217 30.4843 27.1405 30.4843 30.745Z",
    fill: "#1E272D"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.4737 30.0351C22.4737 29.0581 23.219 28.2632 24.134 28.2632C25.049 28.2632 25.7943 29.0581 25.7943 30.0351C25.7943 31.012 25.049 31.807 24.134 31.807C23.219 31.807 22.4737 31.012 22.4737 30.0351Z",
    fill: "#0D1214"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.7034 30.7451C25.7034 31.7038 24.9278 32.4745 23.9765 32.4745C23.0251 32.4745 22.2495 31.6978 22.2495 30.7451C22.2495 29.7924 23.0251 29.0156 23.9765 29.0156C24.9278 29.0156 25.7034 29.7924 25.7034 30.7451Z",
    fill: "url(#paint1_linear_6_19130)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4445 30.745C48.4445 34.3495 45.5299 37.2683 41.9306 37.2683C38.3313 37.2683 35.4167 34.3495 35.4167 30.745C35.4167 27.1405 38.3313 24.2217 41.9306 24.2217C45.5299 24.2217 48.4445 27.1405 48.4445 30.745Z",
    fill: "#1E272D"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.2703 30.0351C40.2703 29.0581 41.0156 28.2632 41.9306 28.2632C42.8456 28.2632 43.5909 29.0581 43.5909 30.0351C43.5909 31.012 42.8456 31.807 41.9306 31.807C41.0156 31.807 40.2703 31.012 40.2703 30.0351Z",
    fill: "#0D1214"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6636 30.7451C43.6636 31.7038 42.888 32.4745 41.9367 32.4745C40.9853 32.4745 40.2097 31.6978 40.2097 30.7451C40.2097 29.7924 40.9853 29.0156 41.9367 29.0156C42.888 29.0156 43.6636 29.7924 43.6636 30.7451Z",
    fill: "url(#paint2_linear_6_19130)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7833 44.5684C19.7833 43.828 20.3469 43.2273 21.0376 43.2273C21.7284 43.2273 22.2919 43.828 22.2919 44.5684C22.2919 45.3087 21.7284 45.9094 21.0376 45.9094C20.3469 45.9094 19.7833 45.3087 19.7833 44.5684Z",
    fill: "#0D1214"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3094 71.851C26.2972 71.7236 26.2791 71.5962 26.2851 71.4687L26.4487 67.221C13.4936 64.193 4.07724 52.3175 4.60441 38.5063C5.2043 22.8503 18.3715 10.6471 34.0049 11.2479C49.6382 11.8486 61.8238 25.0349 61.2239 40.6908C60.721 53.8467 51.3409 64.5631 39.0827 67.2938L39.113 71.9299C39.113 71.9299 38.9009 71.9663 38.9009 71.9724C53.6981 69.2417 65.1686 56.5531 65.7685 40.8668C66.4653 22.6986 52.3226 7.40066 34.1806 6.69675C16.0386 5.9989 0.762722 20.1621 0.0598263 38.3303C-0.570356 54.6719 10.8093 68.6834 26.3094 71.851Z",
    fill: "#4F6B77"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4804 45.2905C19.4379 44.4531 20.0802 43.7431 20.9164 43.7006C21.7526 43.6581 22.4616 44.3014 22.504 45.1388C22.5464 45.9762 21.9041 46.6923 21.0679 46.7287C20.2317 46.7711 19.5228 46.1279 19.4804 45.2905Z",
    fill: "url(#paint3_linear_6_19130)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1211 78.2651H37.7253C40.9247 78.2651 43.5182 75.6679 43.5182 72.4639V67.2817H38.9312L38.9615 71.584C38.9615 72.9736 37.8405 74.0962 36.4529 74.0962H28.8422C27.4546 74.0962 26.3336 72.9736 26.3336 71.584L26.4427 67.2149L22.3222 68.5438V72.4578C22.3222 75.6618 24.9157 78.259 28.1151 78.259L28.1211 78.2651Z",
    fill: "#4F6B77"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9757 72.2637V68.3557H37.9738V72.2637H38.5373V67.6154H27.3152V72.2637H27.9757Z",
    fill: "#65838E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9696 71.1653H37.9677V68.2161H27.9696V71.1653Z",
    fill: "#E6E6E6"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.8513 48.8768C41.8821 48.8768 39.4523 46.5709 39.2463 43.6521C39.1069 44.1497 39.0281 44.6776 39.0281 45.2177C39.0281 48.4399 41.6398 51.0553 44.8573 51.0553C48.0749 51.0553 50.6865 48.4399 50.6865 45.2177C50.6865 44.6655 50.6077 44.1315 50.4623 43.6278C50.2624 46.5587 47.8325 48.8768 44.8573 48.8768H44.8513Z",
    fill: "#0D1214"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7892 48.8768C17.814 48.8768 15.3902 46.5648 15.1842 43.64C15.0448 44.1436 14.96 44.6715 14.96 45.2177C14.96 48.4399 17.5716 51.0553 20.7892 51.0553C24.0068 51.0553 26.6184 48.4399 26.6184 45.2177C26.6184 44.6715 26.5396 44.1436 26.3942 43.64C26.1942 46.5648 23.7644 48.8768 20.7892 48.8768Z",
    fill: "#0D1214"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.9142 57.1599C29.6481 57.1599 26.9456 54.769 26.4427 51.6378C26.4184 51.8624 26.4063 52.093 26.4063 52.3235C26.4063 55.9281 29.3209 58.8469 32.9202 58.8469C36.5195 58.8469 39.4341 55.9281 39.4341 52.3235C39.4341 52.0747 39.4159 51.8259 39.3917 51.5832C38.913 54.7387 36.1984 57.1599 32.9142 57.1599Z",
    fill: "#0D1214"
  }))), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9306 35.5814C38.6524 35.5814 35.9499 33.1723 35.4591 30.029C35.4349 30.2657 35.4167 30.5023 35.4167 30.745C35.4167 34.3495 38.3313 37.2684 41.9306 37.2684C45.5299 37.2684 48.4445 34.3495 48.4445 30.745C48.4445 30.5023 48.4263 30.2657 48.4021 30.029C47.9113 33.1723 45.2027 35.5814 41.9306 35.5814Z",
    fill: "#0D1214"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9704 35.5814C20.6923 35.5814 17.9897 33.1723 17.4989 30.029C17.4747 30.2657 17.4565 30.5023 17.4565 30.745C17.4565 34.3495 20.3711 37.2684 23.9704 37.2684C27.5697 37.2684 30.4843 34.3495 30.4843 30.745C30.4843 30.5023 30.4661 30.2657 30.4419 30.029C29.9511 33.1723 27.2425 35.5814 23.9704 35.5814Z",
    fill: "#0D1214"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.6 21.6488C67.9559 34.307 66.6229 51.8806 55.6189 62.5606C52.1165 66.0195 47.8325 68.7016 43.1546 70.1823C47.5962 68.2586 51.6863 65.4794 54.9827 61.9356C65.3383 51.0917 66.6653 34.6408 59.606 21.6488H59.6Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3283 70.1883C-0.237082 62.6395 -7.0782 33.4757 9.8216 16.6789C12.0394 14.5004 14.5298 12.6011 17.2626 11.1568C12.0939 14.4579 7.78563 19.094 5.02858 24.5676C-3.82428 41.8012 4.55594 62.9368 22.3283 70.1883Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1546 70.7223C43.1728 71.9117 43.1546 73.0889 42.9062 74.2904C42.276 76.0016 40.7854 77.5733 38.9433 77.9253C37.1497 77.992 35.3803 77.8342 33.5989 77.6947C34.7805 77.5733 35.956 77.5187 37.1315 77.4762C37.7011 77.4277 38.3374 77.4762 38.8585 77.3913C40.4521 77.0514 41.8034 75.589 42.482 74.1751C42.7789 73.2224 42.9607 71.7296 43.1546 70.7284V70.7223Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.7822 77.1061C24.1582 76.5296 22.8736 75.0975 22.5283 73.3984C22.5646 72.652 22.6434 71.9117 22.7828 71.1653C22.9039 71.7903 23.0312 72.9372 23.0251 73.3074C23.5159 74.8547 24.5764 76.0563 25.7882 77.1061H25.7822Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.4138 30.9878C53.7465 35.7149 53.9101 42.3232 51.4924 47.5054C49.9957 50.6002 47.5659 53.1792 44.8573 55.212C52.0135 48.2154 53.6435 40.4177 50.4138 30.9878Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.5135 34.574C33.3989 30.9817 35.2895 25.7812 39.6523 24.4644C35.8287 26.5579 34.3078 30.6843 36.5135 34.574Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.233 24.9923C50.8501 27.7048 50.129 35.551 43.9423 36.9892C49.4625 34.8228 49.9897 28.3056 45.233 24.9923Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5108 34.5923C15.3963 30.9999 17.2868 25.7994 21.6496 24.4826C17.8261 26.5762 16.3052 30.7025 18.5108 34.5923Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.2304 25.0106C32.8475 27.723 32.1264 35.5692 25.9397 37.0074C31.4599 34.841 31.9871 28.3238 27.2304 25.0106Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4667 56.1708C24.3521 52.5784 26.2427 47.378 30.6055 46.0612C26.782 48.1547 25.2611 52.2811 27.4667 56.1708Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1802 46.5891C41.7973 49.3016 41.0762 57.1478 34.8895 58.5859C40.4097 56.4196 40.9369 49.9023 36.1802 46.5891Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.2417 51.656C31.2417 50.679 31.9871 49.8841 32.902 49.8841C33.817 49.8841 34.5623 50.679 34.5623 51.656C34.5623 52.633 33.817 53.4279 32.902 53.4279C31.9871 53.4279 31.2417 52.633 31.2417 51.656Z",
    fill: "#0D1214"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6532 52.3235C34.6532 53.2823 33.8776 54.053 32.9263 54.053C31.9749 54.053 31.1993 53.2762 31.1993 52.3235C31.1993 51.3708 31.9749 50.5941 32.9263 50.5941C33.8776 50.5941 34.6532 51.3708 34.6532 52.3235Z",
    fill: "url(#paint4_linear_6_19130)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7435 69.6907H28.3393V71.1653H37.7435V69.6907Z",
    fill: "#65838E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_19130",
    x1: 43.5485,
    y1: 45.2177,
    x2: 46.5782,
    y2: 45.2177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_19130",
    x1: 22.2435,
    y1: 30.7451,
    x2: 25.7034,
    y2: 30.7451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_19130",
    x1: 40.2037,
    y1: 30.7451,
    x2: 43.6636,
    y2: 30.7451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_19130",
    x1: 19.4804,
    y1: -6.52593,
    x2: 22.5101,
    y2: -6.52593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_19130",
    x1: 31.1933,
    y1: 52.3235,
    x2: 34.6532,
    y2: 52.3235,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDE3B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F3B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJ1772Socket);
export default __webpack_public_path__ + "static/media/j1772_socket.e272e13c9e66ff6e2af710a4a398b11e.svg";
export { ForwardRef as ReactComponent };